import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import _ from 'lodash';

import {Dropdown} from 'ui-library';

const SettingsDropdown = createClass({
  propTypes: {
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired
    })),
    position: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'xsm']),
    iconClassName: PropTypes.string
  },

  getDefaultProps() {
    return {
      icon: 'more-vertical',
      size: 'xsm',
      position: 'bottom-left'
    };
  },

  handleClick(callback, evt) {
    evt.stopPropagation();
    evt.preventDefault();
    callback();
  },

  renderOptions() {
    const {options} = this.props;
    return _.chain(options)
      .compact()
      .map(el => (
        <div
          className='vf-settings-dropdown-element vf-clickable'
          key={el.value}
          onClick={this.handleClick.bind(null, el.callback)}
        >
          {el.value}
        </div>
      ))
      .value();
  },

  render() {
    const {className, size, icon, position, iconClassName = ''} = this.props;
    let classes = 'vf-settings-dropdown no-hover';

    if (className) classes += ` ${className}`;

    return (
      <Dropdown
        ref='dropdown'
        className={classes}
        menuClassName='vf-overflow-hidden vf-settings-dropdown-menu'
        size={size}
        title={<div className={`vf-icon icon-${icon} ${iconClassName}`} />}
        position={position}
        showDropdownExpandedIndicator={false}
      >
      <span data-uitest='item-option'>
        {this.renderOptions()}
      </span>
      </Dropdown>
    );
  }

});

module.exports = SettingsDropdown;
